/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamBasic } from './TeamBasic';
import {
    TeamBasicFromJSON,
    TeamBasicFromJSONTyped,
    TeamBasicToJSON,
    TeamBasicToJSONTyped,
} from './TeamBasic';

/**
 * 
 * @export
 * @interface TeamsListResponse
 */
export interface TeamsListResponse {
    /**
     * 
     * @type {Array<TeamBasic>}
     * @memberof TeamsListResponse
     */
    teams?: Array<TeamBasic>;
}

/**
 * Check if a given object implements the TeamsListResponse interface.
 */
export function instanceOfTeamsListResponse(value: object): value is TeamsListResponse {
    return true;
}

export function TeamsListResponseFromJSON(json: any): TeamsListResponse {
    return TeamsListResponseFromJSONTyped(json, false);
}

export function TeamsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': json['teams'] == null ? undefined : ((json['teams'] as Array<any>).map(TeamBasicFromJSON)),
    };
}

export function TeamsListResponseToJSON(json: any): TeamsListResponse {
    return TeamsListResponseToJSONTyped(json, false);
}

export function TeamsListResponseToJSONTyped(value?: TeamsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teams': value['teams'] == null ? undefined : ((value['teams'] as Array<any>).map(TeamBasicToJSON)),
    };
}

